const copyToClipboard = {
  methods: {
    copyToClipboard (element) {
      return new Promise((res) => {
        if (document.selection) {
          // IE
          const range = document.body.createTextRange()
          range.moveToElementText(element)
          range.select()
          document.execCommand('copy')
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(element.value)
        }
        res(true)
      })
    },
    copyTextToClipboard (text) {
      return new Promise((res) => {
        navigator.clipboard.writeText(text)
        res(true)
      })
    }
  }
}

export default copyToClipboard
